export enum TwoFactorEnableSteps {
  BEGIN,
  MANDATORY_SETUP,
  QRCODE,
  CONFIRMATION,
  END,
  BACKUP_LOGIN,
  NEW_BACKUP,
}

export type TwoFactorAuthState = {
  qrcode: string;
  secret: string;
  showModal: boolean;
  loading: boolean;
  backup: string;
  startStep: TwoFactorEnableSteps;
};
